import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ReferralContext = createContext(null);

export function ReferralProvider({ children }) {
  const [referralCode, setReferralCode] = useState(null);
  const [referralData, setReferralData] = useState(null); // banner info from backend
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");

    // Restore previously stored referral
    const stored = localStorage.getItem("ms_referral_code");
    const storedData = localStorage.getItem("ms_referral_data");

    if (ref) {
      setReferralCode(ref);
      localStorage.setItem("ms_referral_code", ref);
      // Fetch banner info; show banner only on fresh arrival via URL
      api
        .get(`/referrals/${encodeURIComponent(ref)}`)
        .then(({ data }) => {
          setReferralData(data);
          localStorage.setItem("ms_referral_data", JSON.stringify(data));
          setShowBanner(true);
        })
        .catch(() => {
          // Unknown code: still keep it tracked, generic banner
          const fallback = {
            code: ref,
            custom_banner_title: "Benvenuto!",
            custom_banner_message:
              "Hai diritto a una consulenza gratuita attivando un servizio tramite questo link.",
            discount_value: "",
          };
          setReferralData(fallback);
          localStorage.setItem("ms_referral_data", JSON.stringify(fallback));
          setShowBanner(true);
        });
    } else if (stored) {
      setReferralCode(stored);
      if (storedData) {
        try {
          setReferralData(JSON.parse(storedData));
        } catch (e) {}
      }
    }
  }, []);

  const dismissBanner = () => setShowBanner(false);

  const clearReferral = () => {
    localStorage.removeItem("ms_referral_code");
    localStorage.removeItem("ms_referral_data");
    setReferralCode(null);
    setReferralData(null);
  };

  return (
    <ReferralContext.Provider
      value={{ referralCode, referralData, showBanner, dismissBanner, clearReferral }}
    >
      {children}
    </ReferralContext.Provider>
  );
}

export const useReferral = () => useContext(ReferralContext);
